<p-dialog
  [(visible)]="display"
  header="{{ 'label.Portfolio' | translate }}"
  (onHide)="onCancel()"
  appendTo="body"
  modal="true"
  width="400"
>
  <div>
    <select
      [ngModel]="portfolios && selectedPortfolio"
      (ngModelChange)="portfolios && (selectedPortfolio = $event)"
    >
      <option
        *ngFor="let item of portfolios"
        [value]="item?.portfolio?.portfolioId"
      >
        {{ item?.portfolio?.name }}
      </option>
    </select>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      (click)="onSave()"
      label="{{ 'label.Save' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCancel()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
